module.exports = "https://s.pinimg.com/webapp/style/images/NN@2x-dcd431b1.png";